import { useState } from "react";
import { Button } from "@/components/ui/button";
import { api, errorMessage } from "@/lib/api";

interface Preview { template_id: string; version: number; added: string[]; removed: string[] }

export function CaseTemplateTransfer({ processId, onSaved }: { processId: string; onSaved: () => void }) {
  const [preview, setPreview] = useState<Preview | null>(null);
  const [busy, setBusy] = useState(false);
  const [message, setMessage] = useState("");
  async function run(confirm = false) {
    if (busy) return;
    setBusy(true); setMessage("");
    try {
      const url = `/dozvole/postupci/${processId}/novi-predlozak`;
      if (confirm && preview) {
        await api.post(url, { template_id: preview.template_id, confirmed: true });
        setPreview(null); onSaved();
      } else {
        const { data } = await api.get<Preview | null>(url);
        setPreview(data);
        if (!data) setMessage("Predmet već koristi najnoviji dostupni predložak.");
      }
    } catch (cause) { setMessage(errorMessage(cause, "Prijenos predloška nije uspio.")); }
    finally { setBusy(false); }
  }
  return <div className="space-y-3">
    <Button variant="secondary" disabled={busy} onClick={() => void run()}>Prebaci na novi predložak</Button>
    {preview && <div role="dialog" aria-label="Potvrdi novi predložak" className="space-y-3 rounded border p-3">
      <p>Predložak v{preview.version}. Obavljeni i preskočeni koraci, dokazi i dnevnik ostaju sačuvani.</p>
      <p>Novi koraci: {preview.added.join(", ") || "nema"}.</p>
      <p>Ne radi se — Uklonjen iz novog predloška: {preview.removed.join(", ") || "nema"}.</p>
      <Button disabled={busy} onClick={() => void run(true)}>Potvrdi prijenos</Button>
      <Button variant="ghost" disabled={busy} onClick={() => setPreview(null)}>Odustani</Button>
    </div>}
    {message && <p role="status">{message}</p>}
  </div>;
}
